import { render, staticRenderFns } from "./Pergamin.vue?vue&type=template&id=761fe344&scoped=true&"
import script from "./Pergamin.vue?vue&type=script&lang=js&"
export * from "./Pergamin.vue?vue&type=script&lang=js&"
import style0 from "./Pergamin.vue?vue&type=style&index=0&id=761fe344&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761fe344",
  null
  
)

export default component.exports